// extracted by mini-css-extract-plugin
export default {"wrapper":"SXKAp","wrapperText":"VwBYu","timerWrapper":"F_fFS","textOffset":"jPiiq","timerText":"enpwO","wrapperArrow":"RG4DD","rArrow":"sTyqj","textStyle":"yubNF"};